import React from 'react'
import './dashboard-wrapper.scss'

/**
 * Wrapper dashboar component
 * 
 * @params props object
 * @returns JSX
 */
const DashboardWrapper = props => {
    return (
        <div className='dashboard-wrapper'>
            {props.children}
        </div>
    )
}

export default DashboardWrapper;

/**
 * Wrapper dashboar main component
 * 
 * @params props object
 * @returns JSX
 */
export const DashboardWrapperMain = props => {
    return (
        <div className='dashboard-wrapper__main'>
            {props.children}
        </div>
    )
}

/**
 * Wrapper dashboar right component
 * 
 * @params props object 
 * @returns JSX
 */
export const DashboardWrapperRight = props => {
    return (
        <div className='dashboard-wrapper__right'>
            {props.children}
        </div>
    )
}